import { render, staticRenderFns } from "./activityInvitationCode.vue?vue&type=template&id=b2e3284e&scoped=true&"
import script from "./activityInvitationCode.vue?vue&type=script&lang=js&"
export * from "./activityInvitationCode.vue?vue&type=script&lang=js&"
import style0 from "./activityInvitationCode.vue?vue&type=style&index=0&id=b2e3284e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e3284e",
  null
  
)

export default component.exports